import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const style = makeStyles((theme) => ({
  container: {
    '& p': {
      marginBottom: '2px',
      marginTop: '2px',
    },

    '& h1': {
      marginTop: 0,
      marginBottom: '5px',
      lineHeight: '2rem',
    },

    '& h2': {
      marginTop: 0,
      marginBottom: '5px',
    },

    '& h3': {
      marginTop: 0,
      marginBottom: '5px',
    },
  },
  toggle: {
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '& svg': {
      verticalAlign: 'middle',
    },
  },
}));

const NewsContent = ({ text }) => {
  const classes = style();

  return (
    <Box component="div" className={classes.container}>
      <Typography component="div" dangerouslySetInnerHTML={{ __html: text }} />
    </Box>
  );
};

NewsContent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NewsContent;
